function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M11.111 15.636H9.333a.9.9 0 01-.889-.909.9.9 0 01.89-.909h1.776V12a.9.9 0 01.89-.91.9.9 0 01.889.91v1.818h1.778a.9.9 0 01.889.91.9.9 0 01-.89.908H12.89v1.819a.9.9 0 01-.889.909.9.9 0 01-.889-.91v-1.818zm7.111-6.363h-4.444a.9.9 0 01-.89-.91V3.819h-6.22a.9.9 0 00-.89.91v14.545a.9.9 0 00.89.909h10.666a.9.9 0 00.89-.91v-10h.888A.9.9 0 0020 8.365v10.909C20 20.779 18.806 22 17.333 22H6.667C5.194 22 4 20.779 4 19.273V4.727C4 3.221 5.194 2 6.667 2h7.11c.237 0 .463.096.63.266l5.333 5.455a.91.91 0 01.192.295zm-3.555-4.17v2.352h2.298l-2.298-2.351z"
});

var SvgFilePlus = function SvgFilePlus(props) {
  return React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/file-plus.d7a6b9c8.svg";
export { SvgFilePlus as ReactComponent };